// legalCaseSteps.js

export const CASE_STEP = {
  CASE_CREATED: "CASE_CREATED",
  DOCS_PENDING: "DOCS_PENDING",
  DOCS_VERIFIED: "DOCS_VERIFIED",
  ADVOCATE_ASSIGNED: "ADVOCATE_ASSIGNED",
  POA_GENERATED: "POA_GENERATED",
  TEMP_BAIL_GRANTED: "TEMP_BAIL_GRANTED",
  DRIVER_BAIL_PETITION_FILED: "DRIVER_BAIL_PETITION_FILED",
  DRIVER_DOCS_VERIFIED_BY_POLICE: "DRIVER_DOCS_VERIFIED_BY_POLICE",
  IO_REPORT_UPLOADED: "IO_REPORT_UPLOADED",
  DRIVER_ORDER_CREATED: "DRIVER_ORDER_CREATED",
  BAILER_DETAILS_ADDED: "BAILER_DETAILS_ADDED",
  DRIVER_BAIL_DONE: "DRIVER_BAIL_DONE",
  VEHICLE_BAIL_PETITION_FILED: "VEHICLE_BAIL_PETITION_FILED",
  VEHICLE_ORDER_CREATED: "VEHICLE_ORDER_CREATED",
  VEHICLE_RELEASE_ORDER: "VEHICLE_RELEASE_ORDER",
  VEHICLE_BAIL_DONE: "VEHICLE_BAIL_DONE",
  VEHICLE_HANDOVER_DONE: "VEHICLE_HANDOVER_DONE",
  CASE_CLOSED: "CASE_CLOSED",
};

export const BAIL_PATH = { DIRECT: "DIRECT", TEMP_BAIL: "TEMP_BAIL" };

export const DRIVER_BAIL_STEPS = [
  CASE_STEP.DRIVER_BAIL_PETITION_FILED,
  CASE_STEP.DRIVER_DOCS_VERIFIED_BY_POLICE,
  CASE_STEP.IO_REPORT_UPLOADED,
  CASE_STEP.DRIVER_ORDER_CREATED,
  CASE_STEP.BAILER_DETAILS_ADDED,
  CASE_STEP.DRIVER_BAIL_DONE,
];

export const VEHICLE_BAIL_STEPS = [
  CASE_STEP.VEHICLE_BAIL_PETITION_FILED,
  CASE_STEP.VEHICLE_ORDER_CREATED,
  CASE_STEP.VEHICLE_RELEASE_ORDER,
  CASE_STEP.VEHICLE_BAIL_DONE,
  CASE_STEP.VEHICLE_HANDOVER_DONE,
];

// Full ordered step list depends on which path was chosen after POA generation.
export function getFullStepOrder(bailPath) {
  const pre = [
    CASE_STEP.CASE_CREATED,
    CASE_STEP.DOCS_PENDING,
    CASE_STEP.DOCS_VERIFIED,
    CASE_STEP.ADVOCATE_ASSIGNED,
    CASE_STEP.POA_GENERATED,
  ];
  if (bailPath === BAIL_PATH.TEMP_BAIL) {
    // Temporary bail granted → vehicle bail happens first, driver bail steps come after.
    return [...pre, CASE_STEP.TEMP_BAIL_GRANTED, ...VEHICLE_BAIL_STEPS, ...DRIVER_BAIL_STEPS, CASE_STEP.CASE_CLOSED];
  }
  // Direct path → driver bail first, then vehicle bail.
  return [...pre, ...DRIVER_BAIL_STEPS, ...VEHICLE_BAIL_STEPS, CASE_STEP.CASE_CLOSED];
}

export function useStepIndex(caseRecord) {
  if (!caseRecord) return { order: [], idx: -1 };
  const order = getFullStepOrder(caseRecord.bailPath);
  return { order, idx: order.indexOf(caseRecord.caseStep) };
}